import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#00B4D8]/20 py-10 px-4" data-id="element-217">
      <div className="max-w-3xl mx-auto text-center" data-id="element-218">
        <div className="text-[#00B4D8] text-2xl font-black tracking-widest mb-4" data-id="element-219">
          🇫🇷 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-220">
          El sistema de enseñanza N°1 para docentes de Francés de secundaria e
          institutos en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-221">
          Porque enseñar Francés no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-222">
          <span data-id="element-223">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-224">•</span>
          <span data-id="element-225">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-226">•</span>
          <span data-id="element-227">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#00B4D8]/20 mb-6" data-id="element-228" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-229">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-230">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-231">
          🇫🇷 "Le prochain dimanche peut être différent."
          <br data-id="element-232" />
          "El próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}